import {
  ColorIcon,
  colors,
  VStack,
  responsive,
  HStack,
  useResponsive,
} from "goi_common";

import ProductPaymentProcessImage from "@/containers/registration/components/ProductPriceContainer/ProductPaymentProcessImage";

import { Flex, Box } from "@chakra-ui/react";

import { 가족장2026 } from "goi_common/src/constants/servicePackages/service2026/가족장";
import { 무빈소장2026 } from "goi_common/src/constants/servicePackages/service2026/무빈소장";
import { 일반장2026 } from "goi_common/src/constants/servicePackages/service2026/일반장";

const services = ["무빈소장" as const, "가족장" as const, "일반장" as const];
const servicePackagesDetail = {
  무빈소장: 무빈소장2026,
  가족장: 가족장2026,
  일반장: 일반장2026,
};
const items = [
  "가격" as const,
  "접객도우미" as const,
  "장례 용품" as const,
  "장의 차량" as const,
];
const suffix: Partial<Record<typeof items[number], string>> = {
  가격: "만 원",
  "장의 차량": "대",
};

export default function ReferioServiceSection() {
  const { isBiggerThanLg } = useResponsive();
  return (
    <VStack
      width="100%"
      alignItems="center"
      background={colors.gray50}
      css={responsive({
        padding: {
          base: "40px 24px 60px",
          lg: "80px 24px",
        },
      })}
    >
      <ColorIcon
        name="icon-match-file"
        color=""
        size={isBiggerThanLg ? 66 : 56}
      />
      <Box
        className="gray900"
        css={responsive({
          fontSize: { base: "24px", lg: "42px" },
          paddingTop: { base: "10px", lg: "16px" },
          fontWeight: "bold",
        })}
        id="service"
      >
        100원 상조 서비스 상세
      </Box>
      <Box
        className="gray600"
        css={responsive({
          fontSize: { base: "14px", lg: "21px" },
          padding: { base: "20px 0px", lg: "40px 0px 20px" },
          textAlign: "center",
        })}
      >
        <b>
          장례 발생시 무빈소장, 가족장, 일반장 중{" "}
          <br className="lg_over_hidden" />
          상품을 선택
        </b>
        하시면 되며, <br />월 100원으로 현재 상품 가격을{" "}
        <br className="lg_over_hidden" />
        장례 시점까지 보장받을 수 있습니다.
      </Box>

      <Box
        css={responsive({
          width: "100%",
          maxWidth: { base: "360px", lg: "600px" },
        })}
      >
        <ProductPaymentProcessImage />
      </Box>

      <HStack
        gap={isBiggerThanLg ? "20px" : "10px"}
        css={responsive({
          margin: { base: "0px 0 20px", lg: "20px 0 40px" },
        })}
      >
        {services.map((name) => (
          <VStack
            gap={isBiggerThanLg ? "4px" : "0px"}
            key={name}
            alignItems="center"
          >
            <Flex
              id={name}
              css={responsive({
                minHeight: "55px",
                color: colors.brown650,
                alignItems: "center",
                fontSize: { base: "16px", lg: "21px" },
                fontWeight: "600",
              })}
            >
              {name}
            </Flex>
            <VStack
              borderRadius={10}
              gap={isBiggerThanLg ? 30 : 20}
              background={colors.white}
              boxShadow={"0px 0px 12px 0px rgba(0, 0, 0, 0.1)"}
              flexGrow={1}
              css={responsive({
                width: { base: "105px", lg: "190px" },
                padding: { base: "16px 8px", lg: "24px 13px" },
              })}
            >
              {items.map((a) => (
                <VStack key={a} alignItems="center">
                  <div
                    css={responsive({
                      color: colors.gray600,
                      fontSize: { base: "12px", lg: "16px" },
                    })}
                  >
                    {a}
                  </div>
                  <div
                    className="subtitle_14_b lg_subtitle_18_b"
                    css={responsive({
                      fontSize: { base: "14px", lg: "18px" },
                      color: colors.gray800,
                    })}
                  >
                    {servicePackagesDetail[name][a]}
                    {suffix[a]}
                  </div>
                </VStack>
              ))}
            </VStack>
          </VStack>
        ))}
      </HStack>
    </VStack>
  );
}
